import typeSafeHandlerImage from "../../../../../src/images/type-safe-handler.png";
import * as React from 'react';
export default {
  typeSafeHandlerImage,
  React
};